import {
  MessageEnvelope,
  MessageListBucketMeta,
  SignalData,
} from '../../schema/message';
import {
  getMessageDayKey,
  getMessageDisplayTimetoken,
} from './message-date-time';

export interface QueryGroupRange {
  groupId: string;
  conversationThreadId: string;
  startTimeToken?: number;
  endTimeToken?: number;
  queryType: string;
  backgroundColor: string;
  title: string;
}

export const getMessageBucket = (
  message: MessageEnvelope,
  growGroupRanges: QueryGroupRange[]
): MessageListBucketMeta => {
  const threadId = message?.message?.conversationThreadId;

  for (const range of growGroupRanges) {
    if (threadId && threadId === range.conversationThreadId) {
      return {
        type: 'query',
        key: `grow-${range.groupId}`,
        groupId: range.groupId,
        lowerBound: range.startTimeToken ?? 0,
        upperBound: range.endTimeToken ?? 0,
        queryType: range.queryType,
        title: range.title,
        backgroundColor: range.backgroundColor,
      };
    }
  }

  const dayKey = getMessageDayKey(message);
  return {
    type: 'day',
    key: `day-${dayKey}`,
    dayKey,
  };
};

export const getGrowGroupRanges = (
  messages: MessageEnvelope[],
  signals: SignalData[]
): QueryGroupRange[] => {
  if (!signals.length) {
    return [];
  }

  const threadRanges = new Map<
    string,
    {
      minToken: number;
      maxToken: number;
    }
  >();

  for (const message of messages) {
    const threadId = message?.message?.conversationThreadId;

    if (!threadId) {
      continue;
    }

    const token = getMessageDisplayTimetoken(message);

    if (Number.isNaN(token)) {
      continue;
    }

    const existing = threadRanges.get(threadId);

    if (existing) {
      existing.minToken = Math.min(existing.minToken, token);
      existing.maxToken = Math.max(existing.maxToken, token);
    } else {
      threadRanges.set(threadId, {
        minToken: token,
        maxToken: token,
      });
    }
  }

  return signals.flatMap((signal) => {
    const range = threadRanges.get(signal.conversationThreadId);

    if (!range) {
      return [];
    }

    return [
      {
        groupId: signal.conversationThreadId,
        conversationThreadId: signal.conversationThreadId,
        startTimeToken: range.minToken,
        endTimeToken: range.maxToken,
        queryType: signal.queryType,
        backgroundColor: signal.color,
        title: signal.title,
      },
    ];
  });
};
